import Checkbox from "@rio-cloud/rio-uikit/components/checkbox/Checkbox";
import { memo } from "react";

interface AssetRow {
	tagName: string;
	isTagSelected: boolean;
	asset: {
		id: string;
		name: string;
	};
	onAssetSelect: (assetId: string) => void;
	isAssetSelected: (assetId: string) => boolean;
	onClick?: () => void;
}

const AssetRow = memo(({ asset, isTagSelected, isAssetSelected, tagName, onAssetSelect, onClick }: AssetRow) => {
	if (!asset) return null;

	return (
		<div
			className={`TreeLeaf form-group margin-bottom-0 ${tagName == "search-results-sidebar" ? "search" : ""}`}
			data-key={asset.id}
			onClick={onClick}
			style={{ cursor: onClick ? "pointer" : "default" }}
		>
			{!isTagSelected && (
				<Checkbox
					className="TreeCheckbox"
					checked={isAssetSelected(asset.id)}
					onChange={(e: any) => {
						e.stopPropagation();
						onAssetSelect(asset.id);
					}}
				/>
			)}
			<span className="TreeLabel">
				<span className="TreeLabelName">
					<span className="rioglyph rioglyph-truck"></span>
					<span className="TreeLabelNameText">
						<span className="TreeLabelNameTextHeadline">{asset.name}</span>
					</span>
				</span>
			</span>
		</div>
	);
});

export default AssetRow;
